define((require, exports, module) => {
    'use strict';

    const removeHtml = require('../tools/string/removeHtml');
    const UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {number} status
     * @param {string} responseText
     */
    function HttpError(stack, source, status, responseText) {
        // eslint-disable-next-line prefer-rest-params
        UploadError.apply(this, arguments);

        this.message = this.message.replace('{STATUS}', status);
        this.radarName = this.radarName.replace('{STATUS}', status);
        this.responseText = removeHtml(responseText)
            .trim()
            .slice(0, 1000);
        this.status = status;
    }

    Object.assign(HttpError, {
        BAD_REQUEST: 400,
        REQUEST_TIMEOUT: 408,
        TOO_LARGE: 413,
        ILLEGAL: 451,
        INTERNAL_SERVER_ERROR: 500,
        BAD_GATEWAY: 502,
        SERVICE_UNAVAILABLE: 503,
        GATEWAY_TIMEOUT: 504,
        INSUFFICIENT_STORAGE: 507,
    });

    HttpError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: HttpError,
        className: 'HttpError',
        radarName: 'error_{SOURCE}_http-{STATUS}',
        message: 'Ошибка HTTP {STATUS}',
        responseText: '',
        status: -1,

        toLogStringPattern:
            '[{TIME}] {ID} {SOURCE} {CLASS_NAME}: {STATUS} – {RESPONSE_TEXT}',

        toLogString() {
            let result = UploadError.prototype.toLogString.apply(
                this,
                // eslint-disable-next-line prefer-rest-params
                arguments,
            );

            result = result.replace('{STATUS}', this.status);
            result = result.replace('{RESPONSE_TEXT}', this.responseText);

            return result;
        },

        getDetails() {
            const details = UploadError.prototype.getDetails.apply(
                this,
                // eslint-disable-next-line prefer-rest-params
                arguments,
            );

            details.status = this.status;
            details.responseText = this.responseText;

            return details;
        },
    });

    module.exports = HttpError;
});
